import { useEffect, useState } from "react";
import { showMessage } from "react-native-flash-message";
import { v4 as uuidv4 } from 'uuid';


export const useTableHelper = () => {

    const [isLoading, setLoading] = useState(false)

    // * Add empty line - Takes already existent object and creates a duplicate with empty values. 
    // * The puprose is to be reused in all similar functionality in the system. 
    // ! For empty tables we will need to return empty line from the API 
    // * Variables : state, sState, Null Attr exceptions, id 
    // * In our Databases there is no consistent way of handling so unfortunately we have to specify all the new IDs
    // * the most common is rowguid 
    const rowAdd = (tableData, setTableData, exceptions = [], boolAttr = [], ref, t, attr = ['company'], intAttr = [], changes = undefined, setChanges = undefined,
        insertData = undefined, setInsertData = undefined, id = 'rowguid', isModal = false, dateTimeAttr = []) => {
        let newData = [];
        // * Allow only one empty line per time
        if (Array.isArray(tableData) && tableData.length > 0) {
            if ((tableData.some(obj => isAllFalseZeroOrEmptyExceptKeys(obj, exceptions)))) {
                if (!isModal) {
                    showMessage({
                        message: t('common:multEmptyLines'),
                        type: "danger",
                        duration: 10000,
                    })
                    return;
                }
                return { message: 'multEmptyLines' };
            }
        }

        // * Define New Object
        let newItem = {};

        if (Array.isArray(tableData)) {
            //* Iterate through and assign null values 
            for (let key in tableData[0]) {
                // * Company is the same for everything and will be ignored in areAllAttributesNullOrEmpty as well
                if (attr.map(item => item.toLowerCase()).includes(key.toLowerCase())) {
                    newItem[key] = tableData[0][key]
                }
                else if (tableData[0].hasOwnProperty(key))
                    newItem[key] = ''

                if (boolAttr.map(item => item.toLowerCase()).includes(key.toLowerCase())) {
                    newItem[key] = false
                }
                if (intAttr.map(item => item.toLowerCase()).includes(key.toLowerCase())) {
                    newItem[key] = 0
                }
                if (dateTimeAttr.map(item => item.toLowerCase()).includes(key.toLowerCase())) {
                    newItem[key] = null
                }
                if (key === id)
                    newItem[id] = uuidv4()
            }
            newData = [newItem, ...tableData];
            if (changes) {
                // * Add new item on top of changes - Index 0
                let newRowChange = { 0: { ...newItem } }
                // * Push all the data one index down. 
                const incrementedData = {};
                Object.keys(changes).forEach((key, index) => {
                    incrementedData[`${index + 1}`] = changes[key];
                });
                // * Append the new row after moving everything one index
                let newChanges = { ...newRowChange, ...incrementedData }
                setChanges(newChanges)
            }
        }
        else newData = [newItem];

        scrollToTop(ref);
        setTableData(newData);
        if (setInsertData !== undefined) {
            setInsertData([newItem[id], ...insertData])
        }

    }

    // * Cancel All Changes
    const handleCancelChanges = (setTableData, originalData, setDeletedItems, setChanges, setDuplicates) => {
        setTableData([...originalData]);
        setDeletedItems([]);
        setChanges({})
    }

    // * For Generalization attribute will be passed to indicate how the id is named - i.e rowguid or salaryschemeId etc 
    const rowDelete = (item, index, attribute, changes, setChanges, tableData, setTableData, setDeletedItems, ref) => {
        // * If it was previously edited then the item will be in changes => Remove
        let c = { ...changes }
        if (index in changes) {
            delete (c[index])
        }
        setChanges(c)
        // * Remove fron front end 
        let array = [...tableData];
        array.splice(index, 1);
        setTableData(array);
        // * Add Id to separate array to be used to remove from backend as well.
        setDeletedItems((prevItems) => [...prevItems, item[attribute]]);
        scrollToTop(ref);

    }

    // * Edit labels
    const rowEdit = (idx, item, key, value, changes, setChanges, tableData, setTableData) => {
        setChanges(prevChanges => {
            // Copy the top-level object
            const c = { ...prevChanges };

            // Helper function to immutably update nested object for idx
            const manageChanges = (innerKey, innerValue) => {
                if (idx in c) {
                    // Create new object at c[idx], copy all keys, and update innerKey
                    c[idx] = {
                        ...c[idx],
                        [innerKey]: innerValue,
                    };
                } else {
                    // Initialize c[idx] from item and set innerKey
                    c[idx] = {
                        ...item,
                        [innerKey]: innerValue,
                    };
                }
            };

            if (key === 'fdate - tdate') {
                manageChanges('fdate', value[0]);
                manageChanges('tdate', value[1]);
            } else {
                manageChanges(key, value);
            }

            if (c[idx].isNew === true) {
                c[idx] = {
                    ...c[idx],
                    oldID: "",
                };
            }

            return c;
        });

        setTableData(prevTableData => prevTableData.map((item, index) => {
            if (key == 'fdate - tdate') {
                return (
                    index === idx ?
                        { ...item, fdate: value[0], tdate: value[1] }
                        : item

                )
            } else
                return (
                    index === idx ?
                        { ...item, [key]: value }
                        : item

                )
        }))
    }
    // * Check for Empty Line 
    // * exceptionAttr - On some tables we have predifined attributes that are not changed by users
    // *               - as a result there is an array to ignore those attributes on this empty line check 
    const areAllAttributesNullOrEmpty = (obj, exceptions = []) => {
        return Object.entries(obj).every(([key, value]) => {
            console.log(key)
            if (exceptions.includes(key)) {
                return false; //* Skip the check for this attribute
            }
            if (typeof value === 'object' && value !== null) {
                return areAllAttributesNullOrEmpty(value, exceptions); //* Recursively check nested objects
            }
            return value === null || value === '' || value === undefined;
        });
    }

    function isAllFalseZeroOrEmptyExceptKeys(obj, excludedKeys = []) {
        return Object.entries(obj)
            .filter(([key]) => !excludedKeys.includes(key))
            .every(([, value]) => value === false || value === 0 || value === '' || value === null);
    }

    const checkDatesDescending = (data) => {
        return data.every((item, index) => {
            if (index === 0) return true; // Skip the first element
            return new Date(item.tdate) <= new Date(data[index - 1].fdate);
        });
    }

    const scrollToTop = (ref) => {
        ref.current?.scrollToOffset({ y: 0, animated: true })
    }

    const hasDuplicates = (dataTable, attribute, setDuplicates) => {
        const seenValues = new Set();
        let attributeVal = [];
        setDuplicates([]);

        const hasDup = dataTable.some(obj => {
            const attrValueLower = String(obj[attribute]).toLowerCase();
            if (seenValues.has(attrValueLower)) {
                attributeVal.push({ attribute, attrVal: obj[attribute] });
                return true;
            }
            seenValues.add(attrValueLower);
            return false;
        });

        if (attributeVal.length > 0) {
            setDuplicates(attributeVal);
        }

        return hasDup;
    };

    return {
        rowAdd, areAllAttributesNullOrEmpty, checkDatesDescending, scrollToTop,
        hasDuplicates, handleCancelChanges, rowDelete, rowEdit, isLoading
    };
}